import React from 'react';
import Component from '@vfuk/core-text-stack';
const TextStack = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default TextStack;
